import type { ReactNode } from 'react'
import { PowerOff } from 'lucide-react'
import { Link } from 'react-router'
import { AuthLoadingState } from '@/features/auth'
// Import direct (pas le barrel `@/features/settings`), comme AppShell : évite le cycle passant par SettingsPage.
import { useModuleVisibilityList } from '@/features/settings/application/moduleVisibilityQueries'

/**
 * Un module désactivé dans Paramètres › Modules l'est aussi par son adresse, pas seulement dans la navigation
 * (ADR-019). Même repli que la navigation : tant que la liste n'est pas connue (chargement, erreur réseau, clé
 * inconnue), le module reste accessible; il n'est fermé que sur une désactivation confirmée par la donnée.
 */
export function RequireModule({
  moduleKey,
  label,
  children,
}: {
  moduleKey: string
  label: string
  children: ReactNode
}) {
  const query = useModuleVisibilityList()
  if (query.isPending) return <AuthLoadingState />
  const module = query.data?.modules.find((candidate) => candidate.moduleKey === moduleKey)
  if (module && !module.isActive) return <ModuleDisabledPage label={module.label || label} />
  return children
}

function ModuleDisabledPage({ label }: { label: string }) {
  return (
    <main className="authorization-state">
      <div>
        <PowerOff aria-hidden="true" />
        <span className="auth-page__eyebrow">Module désactivé</span>
        <h1>{label} est désactivé.</h1>
        <p>
          Ce module est conservé, avec son historique et ses données, mais il a été désactivé dans Paramètres
          › Modules.
        </p>
        <div className="authorization-state__actions">
          <Link to="/vue-ensemble">Retour à l’accueil</Link>
        </div>
      </div>
    </main>
  )
}
